import { useExperimentBucket } from '@carvana/experiment';

type LabelProps = {
  count: number;
  displayName?: string;
  showCount?: boolean;
};

const LabelWithCount = ({
  count = -1,
  displayName = '',
  showCount = true
}: LabelProps) => {
  const experimentBucket = useExperimentBucket('srch-set-reduction2');
  const showWithCount = experimentBucket === 'show-zero-counts' && showCount;

  return (
    <div className="flex gap-8 items-baseline">
      <span>{displayName}</span>
      {showWithCount && count >= 0 ? (
        <span className="!font-bold t-body-xs text-grey-3">
          ({count.toLocaleString()})
        </span>
      ) : null}
    </div>
  );
};

export default LabelWithCount;
